import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NoDataFallback from './NoDataFallback';
import { useUser } from '../../hooks/useUser';
import { getFirstAvailableRoute } from '../../utils/getFirstAvailableRoute';

interface RouteNotFoundProps {
  isHiddenRoute?: boolean;
  hiddenSectionName?: string;
}

const RouteNotFound = ({
  isHiddenRoute = false,
  hiddenSectionName,
}: RouteNotFoundProps) => {
  const navigate = useNavigate();
  const { user } = useUser();

  const fallback = getFirstAvailableRoute(user?.hideSections);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate(fallback.path);
  };

  if (isHiddenRoute) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          p: 3,
          textAlign: 'center',
          width: '100%',
        }}
      >
        <NoDataFallback
          message="Access Restricted"
          description={`This ${hiddenSectionName || 'section'} is currently locked and you don't have access to it. Please contact your administrator if you believe this is a mistake.`}
          httpStatusCode={403}
          clickableWords={{
            contact: 'mailto:support@quibbleai.com',
            administrator: 'mailto:support@quibbleai.com',
          }}
        />
        <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
          <Button
            variant="outlined"
            onClick={handleGoBack}
            sx={{
              textTransform: 'none',
              borderRadius: '6px',
              height: '34px',
              bgcolor: '#FFFFFF',
              color: '#2B2D3F',
              boxShadow: 'none',
            }}
          >
            Go Back
          </Button>
          <Button
            variant="contained"
            onClick={handleGoHome}
            sx={{
              textTransform: 'none',
              borderRadius: '6px',
              height: '34px',
              bgcolor: '#5A4CE6',
              color: '#FFFFFF',
              boxShadow: 'none',
            }}
          >
            Go to {fallback.label}
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        p: 3,
        textAlign: 'center',
        width: '100%',
      }}
    >
      <NoDataFallback
        message="Page Not Found"
        description="The page you are looking for doesn't exist. It might have been moved, deleted, or you entered the wrong URL."
        httpStatusCode={404}
        clickableWords={{
          URL: '#',
        }}
      />
      <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
        <Button
          variant="outlined"
          onClick={handleGoBack}
          sx={{
            textTransform: 'none',
            borderRadius: '6px',
            height: '34px',
            bgcolor: '#FFFFFF',
            color: '#2B2D3F',
            boxShadow: 'none',
          }}
        >
          Go Back
        </Button>
        <Button
          variant="contained"
          onClick={handleGoHome}
          sx={{
            textTransform: 'none',
            borderRadius: '6px',
            height: '34px',
            bgcolor: '#5A4CE6',
            color: '#FFFFFF',
            boxShadow: 'none',
          }}
        >
          Go to {fallback.label}
        </Button>
      </Box>
    </Box>
  );
};

export default RouteNotFound;
